module.exports = __webpack_public_path__ + "assets/apple-icon-60x60.0dd77755.png";